import { useEffect } from 'react';

const BASE_TITLE = 'エージェントハブ';

export function useDocumentTitle(title?: string | null) {
  useEffect(() => {
    if (title && title.trim().length > 0) {
      document.title = `${title} | ${BASE_TITLE}`;
    } else {
      document.title = BASE_TITLE;
    }
  }, [title]);
}
